import { SoftwareAddonTemplate } from "../../../lib/model/addonTemplate";
import slcLogo from "../../images/templates/slc.png";

export const selfLoadingCargoTemplate: SoftwareAddonTemplate = {
  type: "software",
  id: "selfLoadingCargo",
  title: "Self-Loading Cargo",
  platforms: ["msfs", "xplane", "p3d", "fsx"],
  image: slcLogo,
  content: [
    {
      title: "Simulator Setup",
      roles: ["beforeSimFlightStart", "cockpitPreparation"],
      content: [
        {
          item: "Self-Loading Cargo",
          setting: "Started",
        },
        {
          item: "Self-Loading Cargo",
          setting: "Flight Started",
        },
      ],
    },
    {
      title: "Before Flight Start",
      roles: ["beforeFlightStart", "cockpitPreparation"],
      content: [
        {
          item: "APU Startup",
          setting: "Announced",
        },
        {
          item: "Cabin Crew",
          setting: "Begin Boarding",
        },
        {
          header: "After Boarding Started",
        },
        {
          item: "Welcome Announcement",
          setting: "Completed",
        },
      ],
    },
    {
      title: "Before Pushback",
      roles: ["beforePushback"],
      content: [
        {
          item: "GPU",
          setting: "Disconnected",
        },
        {
          item: "Cabin Crew",
          setting: "Arm Doors",
        },
      ],
    },
    {
      title: "Engine Start",
      roles: ["engineStart"],
      content: [
        {
          item: "Engine 2 Start",
          setting: "Announced",
        },
        {
          item: "Engine 1 Start",
          setting: "Announced",
        },
      ],
    },
    {
      title: "Before Takeoff",
      roles: ["beforeTakeoff", "takeoff", "taxi"],
      content: [
        {
          item: "Cabin",
          setting: "Secured",
        },
        {
          item: "Cabin Crew",
          setting: "Seats for Takeoff",
        },
      ],
    },
    {
      title: "Climb",
      roles: ["climbOut"],
      content: [
        {
          item: "Cabin Crew",
          setting: "Released",
        },
      ],
    },
    {
      title: "Cruise",
      roles: ["cruise"],
      content: [
        {
          item: "Cruise Announcement",
          setting: "Completed",
        },
      ],
    },
    {
      title: "Before Descent",
      roles: ["beforeDescent"],
      content: [
        {
          item: "Descent Announcement",
          setting: "Completed",
        },
      ],
    },
    {
      title: "Descent",
      roles: ["descent"],
      content: [
        {
          item: "Descent Started Announcement",
          setting: "Completed",
        },
        {
          header: "After Seatbelt Signs On",
        },
        {
          item: "Cabin Crew",
          setting: "Prepare Cabin for Arrival",
        },
      ],
    },
    {
      title: "Approach",
      roles: ["approach", "landing"],
      content: [
        {
          item: "Cabin",
          setting: "Secured",
        },
        {
          item: "Cabin Crew",
          setting: "Seats for Landing",
        },
      ],
    },
    {
      title: "Arrival",
      roles: ["parking", "shutdown"],
      content: [
        {
          item: "Cabin Crew",
          setting: "Disarm doors",
        },
        {
          item: "Cabin Crew",
          setting: "Allow deboarding",
        },
      ],
    },
  ],
};
